import React     from 'react';
import PropTypes from 'prop-types';

const QuantityCircle = (props) =>
	<div className='dailybonus__mobile--item__middle-block--gift'>
		{props.children}
		<div className="dailybonus__mobile--item__middle-block--gift-quantity">
			{props.quantity}
		</div>
	</div>;

QuantityCircle.propTypes = {
	quantity: PropTypes.number,
	children: PropTypes.node,
};

export default QuantityCircle;
